import React, {useEffect, useState} from 'react';
import {useAppDispatch} from "../app/hooks";
import {Image, Progress} from "antd";
import {setMode} from "../features/omikuji/omikujiSlice";

export function Screen6_Record_wait3sec(props: any) {
    const dispatch = useAppDispatch();
    let currentPercent = 100
    let isMoving = false
    const [percent, setPercent] = useState(currentPercent)
    const getPercentText = (percent: number) => {
        if (percent === 100) {
            return 3
        }
        if (percent >= (100 - 32)) {
            return 2
        }
        if (percent >= (100 - 32 - 32)) {
            return 1
        }
        return 0
    }
    useEffect(() => {
        if (isMoving) return
        isMoving = true
        setInterval(() => {
            const current = currentPercent
            const next = current - 32
            currentPercent = next
            setPercent(currentPercent)
        }, 1000)
    }, [])
    useEffect(() => {
        if (percent < 1) {
            dispatch(setMode("mode7_Clap"))
        }
    }, [percent])
    return <>
        <p>２回手を叩こう</p>
        <p style={{fontWeight: "bold", color: "#369"}}>3秒後に</p>
        <p>録音開始</p>
        <Progress type="circle" percent={percent} format={(percent) => {
            return percent ? getPercentText(percent) : 0
        }
        }/>
        <p>
            <Image
                src="/images/hands.png"
                preview={false}
                alt="AIおみくじ2023"
            />
        </p>
    </>
}
